import moment from "moment";
import getCurrentTimezoneOffset from "./getCurrentTimezoneOffset";

const formatDateToUK = (date) => {
    return new Date(moment(date).add(getCurrentTimezoneOffset(), "minute").toISOString());
}

export default formatDateToUK